
import { Component, Vue, Prop } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import BasicInfo from '../../components/studentDeatil/basic-info.vue'
import CourseRecord from '../../components/studentDeatil/course-record.vue'
import SignRecord from '../../components/studentDeatil/sign-record.vue'
import ConsumerRecord from '../../components/studentDeatil/consumer-record.vue'
import StudentAble from '../../components/studentDeatil/student-able.vue'

@Component({
  name: 'package',
  components: { BasicInfo, CourseRecord, SignRecord, ConsumerRecord, StudentAble }
})
export default class studentInfo extends Vue {
  @Prop() is_show_student_info: boolean
  @Prop() student_info_id: string
  org_id: string = 'd06455545e6d4b929f4fbacbdc93dd24'
  activeName: string = 'first'
  capability: any = ''
  studentId: any = ''
  is_updata: boolean = false
  p_hight: any = window.innerHeight - 100 + 'px'
  mounted() {
    this.getHeight()
  }

  getCapability(val) {
    let data = {
      show_student_value: this.capability
    }
    this.update(data)
  }
  getHeight() {
    window.onresize = () => {
      this.p_hight = window.innerHeight - 100 + 'px'
    }
  }

  getDetails(val) {
    this.capability = val.show_student_value
    this.is_updata = false
  }
  handleClose() {
    this.$emit('close-student', false)
  }
  async update(data) {
      data.student_id = this.student_info_id
      const res: any = await CourseModule.studentUpdate(data)
      if (res.code === 200) {
        this.$message({
          type: 'success',
          message: res.message
        })
        this.is_updata = true
      } else {
        this.$message.error(res.message)
      }
    }
}
